export const FILE_EVENT_TYPE = {
  ATTACH_TO_FUND_REQUEST: "Attach to Fund Request",
  ATTACH_TO_CASH_CLAIM: "Attach to Cash Claim",
  DETACH_FROM_FUND_REQUEST: "Detach from Fund Request",
  DETACH_FROM_CASH_CLAIM: "Detach from Cash Claim",
};
